import styled from "styled-components";
import Form from 'react-bootstrap/Form';

export const Container = styled.div<{ width?: number }>`
  width: ${props => props.width ? `${props.width}px` : "auto"};
  display: flex;
  font-weight: 600;
  font-size: 11px;
  margin: 15px 0 8px;
`;

export const Text = styled.span`
  color: ${({ theme }) => theme.orangeBackground};
  cursor: pointer;
`;

export const ToggleNameContainer = styled.div`
  display: flex;
  flex: 0 auto;
  color: #808080;
  margin-left: 17px;
  margin-right: 121px;
`;

interface ToggleTextProps {
  selected?: boolean;
}

export const ToggleText = styled.div<ToggleTextProps>`
  color: ${({ theme, selected }) => selected ? theme.orangeBackground : theme.darkBlueBackground};
  cursor: ${props => props.selected ? "default" : "pointer"};
`;

export const ToggleShowComplementsContainer = styled.div`
  flex: 5 auto;
`;

export const ToggleEnableEditionContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  flex: 1 auto;

  .custom-switch {
    padding-right: 2.25rem;
    padding-left: 0;
  }

  .custom-switch .custom-control-label::before {
    top: 0;
    right: -2.25rem;
    left: auto;
  }

  .custom-switch .custom-control-label::after {
    top: 2px;
    right: calc(-1.5rem + 2px);
    left: auto;
  }
`;

export const StyledFormCheck = styled(Form.Check)`
  label {
    cursor: pointer;
    color: ${({ theme }) => theme.orangeBackground};
  }
`;
